"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonRow = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_redux_1 = require("react-redux");
var dispatchers_1 = require("../dispatchers");
var selectors_1 = require("../selectors");
var SubComponents = require("./");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ButtonRow = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var dispatchers = (0, dispatchers_1.mapDispatchers)(dispatch);
    var selectors = (0, selectors_1.mapSelectors)();
    var actionOnImportButtonClick = function () {
        return dispatchers.preValidateImportedFiles(props.currentFolder, selectors.cart.data.items.map(function (x) { return x.id; }), props.type);
    };
    return (React.createElement("div", { className: 'button-row' },
        props.mode === 'EDIT' && props.type === 'AUTOMATIC' && (React.createElement(SubComponents.ImportFromCartButton, __assign({ disabled: props.disableWizardFields ||
                (selectors.cart.data.items &&
                    selectors.cart.data.items.length === 0), onClick: actionOnImportButtonClick }, props))),
        React.createElement(sok_ui_1.Column, { small: 6 },
            React.createElement(sok_ui_1.Button, { size: 'medium', color: 'blue', disabled: !(selectors.fileHistory.history.length > 1), onClick: dispatchers.browseHistory(1), text: (0, translation_1.getLocalization)('userfront/order/step3/undo') }),
            React.createElement(sok_ui_1.Button, { size: 'medium', color: 'blue', disabled: props.disableWizardFields ||
                    selectors.fileHistory.changes.length === 0, onClick: dispatchers.browseHistory(-1), text: (0, translation_1.getLocalization)('userfront/order/step3/redo') }),
            React.createElement(sok_ui_1.Button, { size: 'medium', color: 'green', disabled: props.disableWizardFields ||
                    Object.keys(selectors.currentFrame.deleted).length === 0 ||
                    selectors.fileHistory.selectedFiles.filter(function (f) { return !!selectors.currentFrame.deleted[f]; }).length === 0, onClick: function () { return dispatchers.restoreFiles(); }, text: (0, translation_1.getLocalization)('userfront/order/step3/restore') }),
            React.createElement(sok_ui_1.Button, { size: 'medium', color: 'red', disabled: props.disableWizardFields ||
                    selectors.fileHistory.selectedFiles.length === 0 ||
                    selectors.fileHistory.enableRestore, onClick: dispatchers.removeFile(selectors.fileHistory.selectedFiles), text: (0, translation_1.getLocalization)('userfront/order/step3/delete') }))));
};
exports.ButtonRow = ButtonRow;
